/** @jsx isolateComponent */
import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Icon } from '../Icon';
import { Colors, Typography } from '../../../theme';

type Props = {
  /**
   * The content to render within the component.
   */
  children: React.ReactNode;
  /**
   * Click handler for sorting.
   */
  onClick: (e: React.MouseEvent) => void;
};

const Styles = labelStyles('TableHeadSortButton', {
  root: css`
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${Colors.neutral800};
    ${Typography.smallPrint1Bold};
  `,
});

/**
 * Button for sorting a column that's rendered in a `TableHead`.
 * For a non-interactive version, use `TableHeadHeading`.
 */
export const TableHeadSortButton = (props: Props) => {
  return (
    <button type="button" css={Styles.root} onClick={props.onClick}>
      {props.children}
      <Icon color="neutral600" name="arrowDropdown" size={24} />
    </button>
  );
};
